import Vue from 'vue'

// 表格列
export function getTableCols(data) {
    return Vue.axios({
        url: '/api/cache/table_setting',
        method: 'get',
        params: {...data,}

    })
}

export function getTableColsAll(params) {
    return Vue.axios({
        url: '/api/cache/table_setting_all',
        method: 'get',
        params
    })
}

//获取自定义列表
export function getUserColumnSetting(table_name) {
    return Vue.axios({
        url: '/api/user_column_setting/get_info_by', method: 'post', data: {table_name:table_name}

    })
}

//删除自定义列表
export function delUserColumnSetting(id) {
    return Vue.axios({
        url: '/api/user_column_setting/delete', method: 'post', data: {id: id}

    })
}

//保存自定义列表
export function saveUserColumnSetting(tableName, user_columns, hash) {
    return Vue.axios({
        url: '/api/user_column_setting/store', method: 'post', data:{ table_name: tableName, user_columns, hash }

    })
}
